export default __webpack_public_path__ + "static/media/bg12.02d8c658.jpg";